import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useViewerRole from "@/lib/rights/use-viewer-role";
import useShopifyEmbedStatus from "@babackapp/private-api-client/client/use-shopify-embed-status";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@babackapp/ui/components/alert";
import { Button } from "@babackapp/ui/components/button";
import { ExternalLink, Puzzle } from "lucide-react";

export default function EmbedActivationBanner() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const viewerRole = useViewerRole();
  const { data: embedStatus } = useShopifyEmbedStatus(
    shop.shopifyUrl ? shop.id : null,
  );

  // Only "inactive" is a certain answer: "unknown" (scope, theme read error) must not nag the merchant.
  // Enabling the embed needs theme access in Shopify, which other roles usually lack.
  if (
    (viewerRole !== "owner" && viewerRole !== "admin") ||
    embedStatus?.status !== "inactive" ||
    !embedStatus.activationUrl
  ) {
    return null;
  }

  return (
    <Alert variant="warning" className="col-span-4">
      <Puzzle className="size-4" />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <AlertTitle>{t("home.embedActivationBanner.heading")}</AlertTitle>
          <AlertDescription>
            {t("home.embedActivationBanner.message")}
          </AlertDescription>
        </div>
        <Button asChild size="sm" className="w-fit shrink-0">
          <a
            href={embedStatus.activationUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("home.embedActivationBanner.button")}
            <ExternalLink className="size-4" />
          </a>
        </Button>
      </div>
    </Alert>
  );
}
